export const ERROR_RECEIVE = 'ERROR_RECEIVE'
export const CHANGEPWD_REQUEST = 'CHANGEPWD_REQUEST'
export const CHANGEPWD_RECEIVE = 'CHANGEPWD_RECEIVE'

export const SENDEMAILCODE_REQUEST = 'SENDEMAILCODE_REQUEST'
export const SENDEMAILCODE_RECEIVE = 'SENDEMAILCODE_RECEIVE'

export const CHECKEMAILCODE_REQUEST = 'CHECKEMAILCODE_REQUEST'
export const CHECKEMAILCODE_RECEIVE = 'CHECKEMAILCODE_RECEIVE'

export const GETPORDERLIST_REQUEST = 'GETPORDERLIST_REQUEST'
export const GETPORDERLIST_RECEIVE = 'GETPORDERLIST_RECEIVE'

export const GETRORDERLIST_REQUEST = 'GETRORDERLIST_REQUEST'
export const GETRORDERLIST_RECEIVE = 'GETRORDERLIST_RECEIVE'

export const RELATEEMAIL_REQUEST = 'RELATEEMAIL_REQUEST'
export const RELATEEMAIL_RECEIVE = 'RELATEEMAIL_RECEIVE'

export const UPGRADEEMAIL_REQUEST = 'UPGRADEEMAIL_REQUEST'
export const UPGRADEEMAIL_RECEIVE = 'UPGRADEEMAIL_RECEIVE'

export const INTAWARD_REQUEST = 'INTAWARD_REQUEST'
export const INTAWARD_RECEIVE = 'INTAWARD_RECEIVE'

export const INHERIT_REQUEST = 'INHERIT_REQUEST'
export const INHERIT_RECEIVE = 'INHERIT_RECEIVE'

export const GETLOGCODE_REQUEST = 'GETLOGCODE_REQUEST'
export const GETLOGCODE_RECEIVE = 'GETLOGCODE_RECEIVE'

export const CHECKWHITELIST_REQUEST = 'CHECKWHITELIST_REQUEST'
export const CHECKWHITELIST_RECEIVE = 'CHECKWHITELIST_RECEIVE'